import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
// import * as XLSX from 'xlsx';
import * as XLSX from 'xlsx-js-style';
import { Observable } from 'rxjs';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
// const XLSX = require("xlsx-js-style");
@Injectable({ providedIn: 'root' })
export class ExcelDownloadService {
  constructor() {}

  public exportHtmlTableAsExcelFile(
    json: any[],
    excelFileName: string,
    filename_change_not_needed?: boolean
  ): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    var range = XLSX.utils.decode_range(worksheet['!ref']); // get the range
    // const merge = [
    //   { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } },
    //   { s: { r: 1, c: 0 }, e: { r: 1, c: 8 } },
    // ];
    let merge = [
      XLSX.utils.decode_range('A1:J1'),
      XLSX.utils.decode_range('A2:J2'),
    ];
    // worksheet['!merges'] = [
    //   XLSX.utils.decode_range('A1:J1'),
    //   XLSX.utils.decode_range('A2:J2'),
    // ];
    for (var C = 10; C <= range.e.c; ++C) {
      /* find the cell object */
      merge.push({ s: { r: 0, c: C }, e: { r: 0, c: C + 1 } });
    }
    worksheet['!merges'] = merge;
    worksheet['A2'].s = {
      alignment: { horizontal: 'right', vertical: 'center', wrapText: true },
    };
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveAsExcelFile(
      excelBuffer,
      excelFileName,
      filename_change_not_needed
    );
  }

  public exportAsExcelFile(
    json: any[],
    excelFileName: string,
    filename_change_not_needed?: boolean
  ): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(
      excelBuffer,
      excelFileName,
      filename_change_not_needed
    );
  }

  public exportAsExcelFileFixWidthWrapText(
    json: any[],
    excelFileName: string,
    noOfColumns:any,
    filename_change_not_needed?: boolean
  ): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    //Setting fixed width
    worksheet['!cols'] = Array(noOfColumns).fill({ width: 12 })
    //Wrapping text in excel -15809 defect
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = { r: R, c: C };
        const cellRef = XLSX.utils.encode_cell(cellAddress);
        const cell = worksheet[cellRef];
        if (cell && cell.t === 's') {
        cell.s = {alignment:{ wrapText: true }};
        if (!worksheet['!cols']) {
          worksheet['!cols'] = [];
        }
        if (!worksheet['!cols'][cell.c]) {
          worksheet['!cols'][cell.c] = { wch: 12 }; // Set fixed width
        }  
        }
      }
    }

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['Data'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(
      excelBuffer,
      excelFileName,
      filename_change_not_needed
    );
  }

  private saveAsExcelFile(
    buffer: any,
    fileName: string,
    filename_change_not_needed?: boolean
  ): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    if (!!filename_change_not_needed) {
      FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    } else {
      FileSaver.saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    }
  }

  validateExcelFile(
    file: File,
    firstColumnHeading?: string
  ): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        /* Read the Excel file */
        const bstr: string = e.target.result;
        const workbook: XLSX.WorkBook = XLSX.read(bstr, {
          type: 'binary',
        });
        const worksheetName: string = workbook.SheetNames[0];
        const worksheet: XLSX.WorkSheet = workbook.Sheets[worksheetName];
        if (firstColumnHeading) {
          const fileData = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
          });
          //To check if file is empty or not
          if (fileData.length <= 1) {
            observer.next(false);
            return;
          }
          const firstHeading = fileData[0][0];
          const firstHeadingValid =
            firstHeading?.toLowerCase() === firstColumnHeading?.toLowerCase();
          /* Check if the cell is empty */
          if (!firstHeadingValid) {
            observer.next(false);
            return;
          }
        }
        /* Get the data from the first column */
        const range: XLSX.Range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let r = range.s.r; r <= range.e.r; r++) {
          const cellAddress: XLSX.CellAddress = {
            c: 0,
            r,
          };
          const cellRef: string = XLSX.utils.encode_cell(cellAddress);
          const cell: XLSX.CellObject = worksheet[cellRef];
          /* Check if the cell is empty */
          if (!cell || !cell.v) {
            observer.next(false);
            return;
          }
        }
        observer.next(true);
      };
      fileReader.readAsBinaryString(file);
    });
  }
}